import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const storeService = {
  getAll, create, update, remove,
}

const API_URL = API.BASE_URL + '/v1'

export function getAll(filter = {}) {
  return apiHelper(API_URL).get('/stores/admin/all', { params: filter })
}
export function create(data) {
  return apiHelper(API_URL).post('/stores', data)
}
export function update(uuid, data) {
  return apiHelper(API_URL).put(`/stores/${uuid}`, data)
}
export function remove(uuid) {
  return apiHelper(API_URL).delete(`/stores/${uuid}`)
}
